// @flow
import * as React from 'react';
import { TimeField } from 'common/components/neo/InlineFields/TimeField';

import { rankWith, uiTypeIs, or, isStringControl } from '@jsonforms/core';

import useControlProps from '../util/useControlProps';

type Props = {};

const TimeFieldControl = (props: Props): React.Node => {
    const {
        label,
        description,
        path,
        data,
        handleChange,
        visible,
        required,
        errors,
        enabled,
        schema,
        uischema: { options }
    } = useControlProps(props);

    const { icon } = options || {};

    return (
        visible && (
            <TimeField
                label={label}
                value={data ?? ''}
                icon={icon || 'stopwatch'}
                fullWidth
                required={required}
                error={errors}
                disabled={!enabled}
                helperText={errors ? errors : description}
                onChange={value =>
                    handleChange(
                        path,
                        value ? value : schema.default ?? undefined
                    )
                }
            />
        )
    );
};

export default TimeFieldControl;

export const timeFieldControlTester: any = rankWith(
    1,
    or(uiTypeIs('TimeFieldControl'), isStringControl)
);
